// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vg-0";
export var checkoutRateBadgeLink = "_vg-1";